
import { useCallback, useState } from "react"
import izenuAPI from "../../../services/izenuAPI";
import AdLinkBadge from "./AdLinkBadge";
import AdActiveToggle from "./AdActiveToggle";
import EditAdModal from "./EditAdModal";

export default function AdsMiniPlayerCard({ item, onEdited }) {
    const [showOption, setShowOption] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const deleteAds = useCallback(() => {
        const r = window.confirm("Apagar é irreversivel, tem certeza?")
        if (r == true) {
            deleteADS();
            console.log(item);
        }
    });

    const deleteADS = useCallback(async () => {
        setLoading(true);

        try {
            const { data: r } = await izenuAPI.post("/admin/ads/delete.php", { ads_id: item.id, type: 'miniplayer' });
            console.log(r);
            if (r.response) {
                alert("Apagado com sucesso!");
                // Recarrega a lista, senão o cartão apagado continua à vista.
                if (onEdited) onEdited();
                setLoading(false);
                return;
            }

            alert("Impossivel apagar, tenta mais tarde!");
            setLoading(false);
        } catch (error) {
            console.log(error);
            alert("Impossivel apagar, tenta mais tarde!");
            setLoading(false);
        }

    });

    if (loading) {
        return (<div className="relative cursor-pointer border p-2 flex gap-5 flex-row mb-3 items-center  bg-rose-500/30   rounded-lg">
            <span className="text-white">
                A apagar...
            </span>
        </div>);
    }

    return (<div className="relative cursor-pointer border p-2 flex flex-col gap-1 mb-3 rounded-lg">
        <img style={{ opacity: item.active === 0 ? 0.4 : 1 }} onClick={() => setShowOption(true)} className="relative h-auto rounded-lg w-full" src={item.uri} />
        <div className="flex items-center gap-2 flex-wrap">
            <AdActiveToggle type="player" id={item.id} active={item.active} onChanged={() => onEdited && onEdited()} />
            <AdLinkBadge link={item.link} />
        </div>
        {showOption && (<div onClick={() => setShowOption(false)} className="rounded-lg backdrop-blur-sm bg-white/30 flex items-center gap-2 justify-center absolute inset-0">
            <button onClick={(e) => { e.stopPropagation(); setShowOption(false); setEditing(true); }} className="text-sm h-10 px-6 font-medium bg-sky-500 rounded text-white">
                Editar
            </button>
            <button onClick={() => deleteAds()} class="text-sm h-10 px-6 font-medium bg-rose-500 rounded">
                <span className="text-white">
                    Apagar
                </span>
            </button>
        </div>)}
        <EditAdModal open={editing} onClose={() => setEditing(false)} onSaved={() => onEdited && onEdited()} ad={item} type="player" />
    </div>)

}